__turbopack_context__.v({
  "container": "vPKWyG_container",
  "footerContainer": "vPKWyG_footerContainer",
  "imageContainer": "vPKWyG_imageContainer",
  "imageSkeleton": "vPKWyG_imageSkeleton",
  "labelSkeleton": "vPKWyG_labelSkeleton",
  "pageLabelSkeleton": "vPKWyG_pageLabelSkeleton",
  "tabSkeleton": "vPKWyG_tabSkeleton",
  "tabsContainer": "vPKWyG_tabsContainer",
});
